// TriviaDeleteConfirmModal Component
// Confirmation modal for deleting trivia questions

import React from 'react';
import { RevoltModal } from '../../../components/RevoltModal';
import { RevoltButton } from '../../../components/RevoltButton';
import './TriviaDeleteConfirmModal.css';

export function TriviaDeleteConfirmModal({
  isOpen,
  onClose,
  onConfirm,
  trivia = null, // { id: string, question: string }
  isLoading = false
}) {
  if (!trivia) {
    return null;
  }

  const handleConfirm = async () => {
    if (onConfirm) {
      await onConfirm();
    } else {
      onClose();
    }
  };

  const handleCancel = () => {
    onClose();
  };

  return (
    <RevoltModal
      isOpen={isOpen}
      onClose={onClose}
      title="Delete Trivia Question"
      showCloseButton={true}
    >
      <div className="trivia-delete-confirm-content">
        <p className="trivia-delete-confirm-message">
          Are you sure you want to delete this trivia question? This action cannot be undone.
        </p>
        {trivia.question && (
          <div className="trivia-delete-preview">
            <strong>Question:</strong> {trivia.question}
          </div>
        )}
        <div className="trivia-delete-confirm-actions">
          <RevoltButton
            variant="outline"
            onClick={handleCancel}
            disabled={isLoading}
          >
            Cancel
          </RevoltButton>
          <RevoltButton
            variant="danger"
            onClick={handleConfirm}
            disabled={isLoading}
          >
            {isLoading ? (
              <>
                <i className="fa-solid fa-spinner fa-spin" style={{ marginRight: '6px' }}></i>
                Deleting...
              </>
            ) : (
              'Delete Trivia Question'
            )}
          </RevoltButton>
        </div>
      </div>
    </RevoltModal>
  );
}

export default TriviaDeleteConfirmModal;